module.exports = __webpack_public_path__ + "img/down_new_desc.7d9c15a2.png";